import { useMemo } from 'react';
import { useVehicleContext } from '~/contexts/VehicleContext';
import replaceUndefinedWithNull from '~/utilities/replaceUndefinedWithNull';

export function useGetResultTileData() {
  const { vehicle } = useVehicleContext();

  return useMemo(
    () =>
      replaceUndefinedWithNull({
        isFavorite: vehicle?.isFavorite,
        isPurchasePending: vehicle?.isPurchasePending,
        stockNumber: vehicle?.stockNumber,
        totalPrice: vehicle?.price?.total,
        vehicleId: vehicle?.vehicleId
      }),
    [vehicle]
  );
}
